<template>
  <!--搜索框-->
  <div class="filter-container" :class="{ greyBlock: setting.block }">
    <template v-if="questionContent">
      <el-tooltip popper-class="tooltip-pop" effect="dark" :content="questionContent" placement="bottom-end">
        <div slot="content">
          <div v-html="questionContent"></div>
        </div>
        <div class="question-icon-wrapper">
          <img class="question-icon" src="@assets/images/icons/question_icon.png" alt="" />
          <!-- <i class="el-icon-question question-icon"></i> -->
        </div>
      </el-tooltip>
    </template>
    <slot name="fronter"></slot>
    <el-button v-if="formHeight >= hideHeight" class="showBtn blue" type="text" size="mini" @click="isSpread = !isSpread">
      {{ isSpread ? "隐藏" : "更多搜索" }}
    </el-button>
    <div class="form-wrap" :style="{ height: isSpread ? formHeight + 'px' : formHeight >= hideHeight ? hideHeight - 50 + 'px' : 'auto' }">
      <el-form ref="form" id="form" size="small" :inline="setting.inline !== false" :model="searchObj" :label-position="setting.labelPosition" :label-width="setting.labelWidth || 'auto'">
        <template v-for="(item, index) in searchItems">
          <template v-if="item.show !== false">
            <template v-if="item.type === 'select'">
              <el-form-item :label="item.label" :prop="item.key" :key="item.key">
                <el-select
                  v-model="searchObj[item.key]"
                  @change="valueChange(item.key)"
                  :remote="item.remote || false"
                  filterable
                  :remote-method="item.remoteMethod"
                  :size="item.size"
                  :multiple="item.multiple"
                  :style="item.style ? item.style : setting.itemStyle"
                  :placeholder="item.placeHolder"
                  :loading="item.loading"
                  :key="index + 1"
                  :clearable="item.clearable === false ? false : true"
                  :collapseTags="item.collapseTags ? true : false"
                  transfer="true"
                  :popper-append-to-body="true"
                  :disabled="item.disabled"
                >
                  <el-option v-for="selectItem in item.selectOptions" :key="item.selectProps && item.selectProps.value ? selectItem[item.selectProps.value] : selectItem.value" :label="item.selectProps && item.selectProps.label ? selectItem[item.selectProps.label] : selectItem.label" :value="item.selectProps && item.selectProps.value ? selectItem[item.selectProps.value] : selectItem.value" />
                </el-select>
              </el-form-item>
            </template>
            <template v-else-if="item.type === 'selectArray'">
              <el-form-item :label="item.label" :prop="item.key" :key="item.key">
                <el-select
                  v-model="searchObj[item.key]"
                  @change="selectArrayValueChange(item)"
                  :remote="item.remote || false"
                  filterable
                  :remote-method="item.remoteMethod"
                  :size="item.size"
                  :multiple="item.multiple"
                  :style="item.style ? item.style : setting.itemStyle"
                  :placeholder="item.placeHolder"
                  :loading="item.loading"
                  :key="index + 1"
                  :clearable="item.clearable === false ? false : true"
                  :collapseTags="item.collapseTags ? true : false"
                  transfer="true"
                  :popper-append-to-body="true"
                  :disabled="item.disabled"
                >
                  <el-checkbox class="select-array-checkbox" v-model="item.checkAll" :indeterminate="item.isIndeterminate" @change="(val) => selectAll(item, val)">全选</el-checkbox>
                  <el-option v-for="selectItem in item.selectOptions" :key="item.selectProps && item.selectProps.value ? selectItem[item.selectProps.value] : selectItem.value" :label="item.selectProps && item.selectProps.label ? selectItem[item.selectProps.label] : selectItem.label" :value="item.selectProps && item.selectProps.value ? selectItem[item.selectProps.value] : selectItem.value" />
                </el-select>
              </el-form-item>
            </template>
            <template v-else-if="item.type === 'datePicker'">
              <el-form-item :label="item.label" :prop="item.key" :key="item.key">
                <el-date-picker
                  v-if="item.datePickerOption && item.datePickerOption.range"
                  :style="item.style ? item.style : setting.itemStyle"
                  align="left"
                  :size="item.size"
                  :key="item.key"
                  @change="valueChange(item.key)"
                  v-model="searchObj[item.key]"
                  :type="item.datePickerOption.dateType"
                  :disabled="item.disabled"
                  unlink-panels
                  :range-separator="item.datePickerOption.rangeSeparator"
                  :start-placeholder="item.datePickerOption.startTime"
                  :end-placeholder="item.datePickerOption.endTime"
                  :picker-options="item.limitEndTime ? newPickerOptions : pickerOptions ? pickerOptions : []"
                  :value-format="item.datePickerOption.valueFormat"
                  :default-time="item.datePickerOption.defaultTime"
                  :default-value="item.datePickerOption.defaultValue"
                />
                <el-date-picker
                  v-else
                  align="left"
                  :size="item.size"
                  :style="item.style ? item.style : setting.itemStyle"
                  :key="item.key"
                  @change="valueChange(item.key)"
                  v-model="searchObj[item.key]"
                  :type="item.datePickerOption.dateType"
                  :placeholder="item.placeholder"
                  :value-format="item.datePickerOption.valueFormat"
                  :default-time="item.datePickerOption.defaultTime"
                  :picker-options="item.limitEndTime ? newPickerOptions : pickerOptions ? pickerOptions : []"
                />
              </el-form-item>
            </template>

            <template v-else-if="item.type === 'cascader'">
              <el-form-item :label="item.label" :prop="item.key" :key="item.key">
                <el-cascader
                  :style="item.style ? item.style : setting.itemStyle"
                  v-model="searchObj[item.key]"
                  :options="item.cascaderOptions"
                  :size="item.size"
                  :props="{
                    multiple: item.multiple,
                    checkStrictly: item.checkStrictly,
                    ...(item.props || {}),
                  }"
                  :disabled="item.disabled"
                  clearable
                  :filterable="item.cantfilter ? true : false"
                  @change="valueChange(item.key)"
                  :placeholder="item.placeHolder"
                  :key="item.key"
                  :collapse-tags="item.collapseTags"
                />
              </el-form-item>
            </template>
            <template v-else-if="item.type === 'cascaderArray'">
              <!-- 仅支持 checkStrictly = false 
                  multiple —— 多选
                  checkAll —— 全选状态
                  isIndeterminate —— 部分选中
                  collapseTags —— 
                  levelKey —— 树形结构 层级key { levelKey: 1, childList: [{ levelKey: 2 }] } （用于全选时的逻辑判断）
                  totalNum —— 可选总数 （用于判断是否全选）
                  firstNodeValue —— 第一个下拉选项的值 （用于渲染全选复选框）
              -->
              <el-form-item :label="item.label" :prop="item.key" :key="item.key">
                <el-cascader
                  :style="item.style ? item.style : setting.itemStyle"
                  v-model="searchObj[item.key]"
                  :options="item.cascaderOptions"
                  :size="item.size"
                  :props="{
                    multiple: item.multiple,
                    checkStrictly: item.checkStrictly,
                    ...(item.props || {}),
                  }"
                  :disabled="item.disabled"
                  clearable
                  :filterable="item.cantfilter ? true : false"
                  @change="cascaderArrayValueChange(item)"
                  :placeholder="item.placeHolder"
                  :key="item.key"
                  :collapse-tags="item.collapseTags"
                  popper-class="cascader-array"
                >
                  <template slot-scope="scope">
                    <el-checkbox class="cascader-array-checkbox" v-if="item.firstNodeValue == scope.data[item.props.value]" v-model="item.checkAll" :indeterminate="item.isIndeterminate" @change="(val) => cascaderSelectAll(item, val)">全选</el-checkbox>
                    <span>{{ scope.data[item.props.label] }}</span>
                  </template>
                </el-cascader>
              </el-form-item>
            </template>
            <template v-else-if="item.type === 'radio'">
              <el-form-item :label="item.label" :prop="item.key" :key="item.key">
                <el-radio-group v-model="searchObj[item.key]" :style="item.style ? item.style : setting.itemStyle" :size="item.size" justify="end" @change="valueChange(item.key)" :key="index + 1">
                  <template v-for="(selectItem, redioIndex) in item.radioOptions">
                    <el-radio-button :label="selectItem.value" :key="redioIndex">
                      {{ selectItem.label }}
                    </el-radio-button>
                  </template>
                </el-radio-group>
              </el-form-item>
            </template>
            <template v-else-if="item.type === 'inputWithselect'">
              <el-form-item :label="item.label" :prop="item.key" :key="item.key">
                <el-input :size="item.size" :placeholder="item.placeHolder" @input="valueChange(item.key)" :style="item.style ? item.style : setting.itemStyle" v-model.trim="searchObj[item.key]" class="input-with-select" :maxlength="item.maxlength ? item.maxlength : false" clearable>
                  <el-select v-model="searchObj[item.selectListKey]" :style="item.selectListStyle ? item.selectListStyle : ''" slot="prepend" :placeholder="item.selectListPlaceHolder || '类型'" transfer="true" :popper-append-to-body="true">
                    <el-option :label="select.label" :value="select.value" v-for="select in item.selectList" :key="select.value"></el-option>
                  </el-select>
                </el-input>
              </el-form-item>
            </template>
            <template v-else-if="item.type === 'digital-Interval'">
              <el-form-item
                :label="item.label"
                :prop="item.key1"
                :key="item.key1"
                :rules="[
                  {
                    validator: (rule, value, callback) => {
                      const one = Number(value);
                      const max = Number(searchObj[item.key2]);
                      if (!max || one <= max) {
                        callback();
                      } else {
                        searchObj[item.key1] = '';
                        callback('数字区间有误');
                      }
                    },
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input clearable type="number" :size="item.size" :placeholder="item.placeHolder" @input="valueChange(item.key)" :style="item.style ? item.style : setting.itemStyle" v-model="searchObj[item.key1]" oninput="value=value.replace(/\D|^/g,'')" onkeyup="value=value.replace(/\D|^/g,'')" onafterpaste="value=value.replace(/\D|^/g,'')"></el-input>
                -
              </el-form-item>

              <el-form-item
                :prop="item.key2"
                :key="item.key2"
                :rules="[
                  {
                    validator: (rule, value, callback) => {
                      const one = Number(value);
                      const max = Number(searchObj[item.key1]);
                      if (!max || one >= max) {
                        callback();
                      } else {
                        searchObj[item.key2] = '';
                        callback('数字区间有误');
                      }
                    },
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input clearable type="number" :size="item.size" :placeholder="item.placeHolder" @input="valueChange(item.key)" :style="item.style ? item.style : setting.itemStyle" v-model="searchObj[item.key2]" oninput="value=value.replace(/\D|^/g,'')" onkeyup="value=value.replace(/\D|^/g,'')" onafterpaste="value=value.replace(/\D|^/g,'')"></el-input>
              </el-form-item>
            </template>

            <template v-else-if="item.type === 'input-number'">
              <el-form-item :label="item.label" :prop="item.key" :key="item.key">
                <el-input-number
                  v-model.number="searchObj[item.key]"
                  :min="item.min ? item.min : '-Infinity'"
                  :max="item.max ? item.max : 'Infinity'"
                  :type="item.inputType ? item.inputType : 'text'"
                  :maxlength="item.maxlength ? item.maxlength : false"
                  :size="item.size"
                  :placeholder="item.placeHolder"
                  @input="valueChange(item.key)"
                  :style="item.style ? item.style : setting.itemStyle"
                  clearable
                  :key="index + 1"
                />
              </el-form-item>
            </template>

            <template v-else-if="item.type === 'slot'">
              <slot :name="'slot-' + item.key" v-bind:data="{ searchItem: item, searchObj: searchObj, valueChange: valueChange }"></slot>
            </template>
            <template v-else>
              <el-form-item :label="item.label" :prop="item.key" :key="item.key">
                <el-input v-model.trim="searchObj[item.key]" :type="item.inputType ? item.inputType : 'text'" :maxlength="item.maxlength ? item.maxlength : false" :size="item.size" :placeholder="item.placeHolder" @input="valueChange(item.key, $event)" :style="item.style ? item.style : setting.itemStyle" clearable :key="index + 1" />
              </el-form-item>
            </template>
            <br v-if="item.break" :key="index" />
          </template>
        </template>
        <el-form-item>
          <slot name="inlineActionBtn"></slot>
        </el-form-item>
      </el-form>
    </div>
    <slot name="actionBtn" class="mt20"></slot>
  </div>
</template>
<script>
  import Vue from "vue";

  const todayYear = new Date().getFullYear();
  const todayMonth = new Date().getMonth();
  const todayDay = new Date().getDate();
  const end = new Date(todayYear, todayMonth, todayDay, "23", "59", "59");
  const start = new Date(todayYear, todayMonth, todayDay, "00", "00", "00");
  export default Vue.extend({
    data() {
      return {
        searchItems: [],
        searchObj: {},
        pickerOptions: {
          shortcuts: [
            {
              text: "今天",
              onClick(picker) {
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近一周",
              onClick(picker) {
                picker.$emit("pick", [new Date(start.getTime() - 3600 * 1000 * 24 * 7), end]);
              },
            },
            {
              text: "最近一个月",
              onClick(picker) {
                picker.$emit("pick", [new Date(start.getTime() - 3600 * 1000 * 24 * 30), end]);
              },
            },
            {
              text: "最近三个月",
              onClick(picker) {
                picker.$emit("pick", [new Date(start.getTime() - 3600 * 1000 * 24 * 90), end]);
              },
            },
          ],
        },
        newPickerOptions: {
          disabledDate: (time) => {
            let nowDate = new Date();
            let endTime = new Date(nowDate.toLocaleDateString() + " 23:59:59").getTime();
            return time.getTime() > endTime;
          },
          shortcuts: [
            {
              text: "今天",
              onClick(picker) {
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近一周",
              onClick(picker) {
                picker.$emit("pick", [new Date(start.getTime() - 3600 * 1000 * 24 * 7), end]);
              },
            },
            {
              text: "最近一个月",
              onClick(picker) {
                picker.$emit("pick", [new Date(start.getTime() - 3600 * 1000 * 24 * 30), end]);
              },
            },
            {
              text: "最近三个月",
              onClick(picker) {
                picker.$emit("pick", [new Date(start.getTime() - 3600 * 1000 * 24 * 90), end]);
              },
            },
          ],
        },
        isSpread: false,
        formHeight: 0,
        observer: null,
      };
    },
    model: {
      prop: "queryObj",
      event: "value-change",
    },
    props: {
      setting: {
        type: Object,
        default: function () {
          return {};
        },
      },
      searchOption: {
        type: Array,
        default: function () {
          return [];
        },
      },
      searchBtnLoading: {
        type: Boolean,
        default: false,
      },
      queryObj: {
        type: Object,
        default: function () {
          return {};
        },
      },
      questionContent: {
        type: String,
        default: "",
      },
      hideHeight: {
        type: Number,
        default: 150,
      },
    },
    watch: {
      searchOption() {
        this.setSearchItems();
      },
      queryObj: {
        handler() {
          this.walkObj(
            this.queryObj,
            function (value, key) {
              this.$set(this.searchObj, key, value);
            },
            this
          );
        },
        deep: true,
        immediate: true,
      },
    },
    created() {
      this.setSearchItems();
    },
    mounted() {
      this.formHeight = this.$refs.form.$el.offsetHeight;
      let MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
      this.observer = new MutationObserver(() => {
        this.formHeight = this.$refs.form.$el.offsetHeight;
      });
      this.observer.observe(this.$refs.form.$el, {
        childList: true, // 子节点的变动（新增、删除或者更改）
        attributes: true, // 属性的变动
        characterData: true, // 节点内容或节点文本的变动
        subtree: true, // 是否将观察器应用于该节点的所有后代节点
      });

      window.addEventListener("resize", this.changeFormHeight);
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.changeFormHeight);
      this.observer.disconnect();
      this.observer.takeRecords();
      this.observer = null;
    },
    methods: {
      recursiveCascader(cascaderOptions, curCheckedList, item, valueLevelList) {
        for (let i = 0; i < cascaderOptions.length; i++) {
          valueLevelList.push(cascaderOptions[i][item.props.value]);
          if (cascaderOptions[i][item.props.children] && cascaderOptions[i][item.props.children].length > 0) {
            this.recursiveCascader(cascaderOptions[i][item.props.children], curCheckedList, item, valueLevelList);
          } else {
            curCheckedList.push([...valueLevelList]);
            valueLevelList.splice(cascaderOptions[i][item.levelKey] - 1, valueLevelList.length - cascaderOptions[i][item.levelKey] + 1);
          }
          if (i == cascaderOptions.length - 1) valueLevelList.pop();
        }
      },
      cascaderSelectAll(item, val) {
        item.isIndeterminate = false;
        if (val == true) {
          const curCheckedList = [];
          this.recursiveCascader(item.cascaderOptions, curCheckedList, item, []);
          this.searchObj[item.key] = curCheckedList;
        } else {
          this.searchObj[item.key] = [];
        }
        this.valueChange(item.key);
      },
      cascaderArrayValueChange(item) {
        const checkedCount = this.searchObj[item.key].length;
        item.checkAll = checkedCount === item.totalNum;
        item.isIndeterminate = checkedCount > 0 && checkedCount < item.totalNum;
        this.valueChange(item.key);
      },
      selectAll(item, val) {
        item.isIndeterminate = false;
        if (val) {
          this.searchObj[item.key] = item.selectOptions.map((option) => {
            return option.value;
          });
        } else this.searchObj[item.key] = [];
        this.valueChange(item.key);
      },
      selectArrayValueChange(item) {
        const checkedCount = this.searchObj[item.key].length;
        item.checkAll = checkedCount === item.selectOptions.length;
        item.isIndeterminate = checkedCount > 0 && checkedCount < item.selectOptions.length;
        this.valueChange(item.key);
      },
      setSearchItems() {
        console.log("setSearchItems");
        this.searchItems = this.searchOption;

        const remoteSelectOptions = this.searchItems.filter((item) => item.type === "select" && item.selectOptionsApi && !item.selectOptions);
        if (remoteSelectOptions.length) this.getRemoteSelectOptions(remoteSelectOptions);

        const remoteCascaderOptions = this.searchItems.filter((item) => item.type === "cascader" && item.cascaderOptionsApi && !item.cascaderOptions);
        if (remoteCascaderOptions.length) this.getRemoteCascaderOptions(remoteCascaderOptions);
      },
      getRemoteCascaderOptions(remoteCascaderOptions) {
        remoteCascaderOptions.forEach((item) => {
          let { fn } = item.cascaderOptionsApi;
          fn({}).then((res) => {
            console.log("cascaderOptions", res);
            if (res.code === 200 && res.data) {
              item.cascaderOptions = res.data;
              this.updateItem(item.key, item);
            } else {
              this.$message.error(res.message);
            }
          });
        });
      },
      getRemoteSelectOptions(remoteSelectOptions) {
        remoteSelectOptions.forEach((item) => {
          let { fn, selectOptionKeyMap } = item.selectOptionsApi;
          if (!selectOptionKeyMap) {
            selectOptionKeyMap = {
              label: "value", // 接口返回的中文是value
              value: "key", // 接口返回的英文是key
            };
          }
          fn({}).then((res) => {
            if (res.code === 200 && res.data) {
              item.selectOptions = res.data.map((i) => ({
                label: i[selectOptionKeyMap.label],
                value: i[selectOptionKeyMap.value],
              }));
              this.updateItem(item.key, item);
            } else {
              this.$message.error(res.message);
            }
          });
        });
      },
      updateItem(key, newItem) {
        const index = this.searchItems.findIndex((i) => i.key === key);
        console.log("updateItem", key, newItem);
        this.searchItems.splice(index, 1, newItem);
      },
      changeFormHeight() {
        this.formHeight = this.$refs.form.$el.offsetHeight;
      },
      valueChange(key) {
        console.log("valueChange", this.searchObj, key);
        this.$emit("value-change", this.searchObj);
        this.$emit("form-item-change", key);
        this.$emit("change", this.searchObj);
      },
      resetForm() {
        this.$refs.form.resetFields();
      },
      walkObj(obj, handler, context) {
        let keys = Object.keys(obj);
        let len = keys.length;
        let key = null,
          value = null;
        for (let i = 0; i < len; i++) {
          key = keys[i];
          value = obj[key];
          if (handler) {
            let stop = handler.call(context, value, key, obj);
            if (stop) {
              return;
            }
          }
        }
      },
    },
  });
</script>
<style lang="less" scoped>
  .filter-container {
    position: relative;
    margin-bottom: 20px;
    text-align: left;

    .showBtn {
      position: absolute;
      z-index: 100;
      right: 30px;
      bottom: 20px;
      font-size: 14px;
    }

    .form-wrap {
      position: relative;
      overflow: hidden;
      transition: all 0.3s;
    }

    &.greyBlock {
      padding: 20px 30px;
      background: #f8f8fb;
    }

    .question-icon-wrapper {
      position: absolute;
      top: 20px;
      right: 20px;

      .question-icon {
        width: 24px;
        height: 24px;
      }
    }
  }

  /deep/ .el-form-item__label {
    padding-right: 0;
  }

  .select-array-checkbox {
    width: 100%;
    padding-right: 20px;
    text-align: right;
  }

  /deep/ .el-select__input {
    margin-left: 10px;
  }
</style>

<style lang="less">
  .cascader-array {
    .el-cascader-menu__list {
      padding-top: 40px;
    }
    .cascader-array-checkbox {
      position: absolute;
      top: -34px;
      left: 20px;
    }
  }
</style>
